export const TimeQcFieldName = 'timeQcFieldComponent';
